// Created by Apiwat
// 23 June 2020
// Copyright OKKAMI

import styled from "styled-components";

const TitleProduct = styled.div`
  margin: auto 0;
  color: gray;
  padding: 16px;
  text-align: center;
  font-size: 16px;
`;

const FormAsk = styled.div`
  width: 80%;
  text-align: center;
  margin: 0px auto;
`;

const SubTitleProduct = styled.div`
  margin: auto 0;
  font-weight: normal;
  color: gray;
  padding: 16px;
  text-align: center;
  font-size: 14px;
`;

const MiddleContainer = styled.div`
  position: absolute;
  border-radius: 16px;
  border-style: solid;
  border-width: thin;
  border-color: gray;
  background-color: white;
  width: 300px;
  height: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-bottom: 16px;
`;

export { TitleProduct, SubTitleProduct, MiddleContainer, FormAsk };
